import React from 'react';
import {
    Netlify,
    MyBlogsImg, MyProjmg,
    HtmlImg, CssImg, GitImg, HostingImg,
    GooglingImg, ReactImg, JSImg, BootstrapImg, HeaderImage
} from '../imgs/images';
import ZuberDungeCV from "./../imgs/Zuber FrontEnd CV.pdf"
import { Link } from 'react-router-dom';
import '../styles.css';
import '../popup.css';
import '../try.css';
import '../App.css';
import Fade from 'react-reveal/Fade';
// <a href="#"> <span className="resume-btn">Get Resume</span> </a>
export default function Intro() {
    return (
        <>
            <Fade bottom> <div className="main-intro padding2tb " translate="no">
                <div >
                    <div className="hey-heading">Heya!!! <br />
                        <span className="zuber-heading"> I'm Zuber Dunge,</span><br />
                        <span className="web-dev-heading">A FrontEnd Developer. </span>
                        <div className="tag-line"> Bringing mock-ups to life using my SuperPowers.</div >
                    </div>
                    <div className="buttonshire">  <Link to="./Contact" > <span className="hire-me-btn"> Hire Me</span> </Link>

        </div>

                </div>
                <div className="intro-home-img-main"><img className="hero-img" src={HeaderImage} alt="Zuber Dunge Header" /></div>


            </div>
            </Fade>
            <a href="#my-skills">
                {" "}
                <div className="container-parent">
                    {" "}
                    <div class="container-down">
                        <div class="chevron"></div>
                        <div class="chevron"></div>
                        <div class="chevron"></div>
                        {/* <span class="text">Scroll down</span> */}
                    </div>
                </div>{" "}
            </a>

            <section id="my-skills" className="section padding8tb ow">
                <div className="container center-button container-center">
                    <h1 className="skill-color skill-heading">About</h1>
                </div>
                <br />

                <div className="flex-grid">
                    <Fade top>
                        <div className="skills-home">
                            {/* <img src={MySkills} alt="Skills Section Header" /> */}
                            <h2>About Me</h2>
                            <p>I'm a web designer & front-end developer with professional training.
                                I'm interested in all kinds of visual communication,
                                but my major focus is on designing web, mobile & tablet
                                interfaces.</p>

                            <p>I enjoy turning complex problems into simple,
                                beautiful and intuitive designs. When I'm not pushing pixels,
                                you'll find me scrolling twitter checking out #ReactJS posts, playing with my cat or eating probably.</p>
                            <p><b>I'm Good at Graphics Designing too :) </b></p>


                            <div className="marg3tbrem">
                                {" "}

                                <div> <h2>Education</h2>{" "}
                                    <hr />
                                    <div className="flex-education">

                                        <div className="work-flex">   <div className="flex-edu ">  <span className="college-name">Pune University </span>
                                            <span className="passing-year">2018-2021</span>
                                        </div>
                                            <h3>Diploma in Computer Engineering</h3>

                                        </div></div></div>

                            </div>
                        </div>
                    </Fade>
                    <Fade bottom>
                        <div><h2 className="skill-heading-new">Technologies</h2>
                            <div className="grid-skill">
                                <div className="grid-skill-img html-img">
                                    <img src={HtmlImg} alt="HTML LOGO" />
                                    <div> HTML</div>
                                </div>
                                <div className="grid-skill-img css-img">
                                    <img src={CssImg} alt="CSS LOGO" />
                                    <div> CSS3</div>
                                </div>
                                <div className="grid-skill-img js-img">
                                    <img src={JSImg} alt="JS LOGO" />
                                    <div> JavaScript</div>
                                </div>
                                <div className="grid-skill-img node-img">
                                    <img src={Netlify} alt="NodeJS LOGO" />
                                    <div> Hosting</div>
                                </div>
                                <div className="grid-skill-img react-img">
                                    <img src={ReactImg} alt="ReactJS LOGO" />
                                    <div> ReactJS</div>
                                </div>
                                <div className="grid-skill-img git-img">
                                    <img src={GitImg} alt="GIT LOGO" />
                                    <div> Git</div>
                                </div>
                                <div className="grid-skill-img host-img">
                                    <img src={HostingImg} alt="Web Hosting LOGO" />
                                    <div style={{ textAlign: "center" }}> Sass</div>
                                </div>
                                <div className="grid-skill-img goog-img" >
                                    <img src={BootstrapImg} alt="Bootstrap LOGO" />
                                    <div> Bootstrap</div>
                                </div>
                                <div className="grid-skill-img goog-img" >
                                    <img src={GooglingImg} alt="Google LOGOG" />
                                    <div> Googling</div>
                                </div>
                                <span className="text-item-grid">I like to explore new things, currently exploring Figma & looking forward to TypeScript.</span>
                            </div>

                        </div>
                    </Fade>

                </div>

                <br />

            </section>


            <div className="blog-project">
                <Fade left>
                    <div className="project-card-intro">
                        <div className="project-web-section">
                            <div className="my-heading">My Projects</div>
                            <div className="web-sub-text-my-section">I like to showcase my work and thus, you can see my projects hosted online
                                with source code. Click below to see.</div>

                            {/* <div className="flex">See Projects <Link to="./Projects" className="arrow"> <i class="fas fa-arrow-circle-right"></i></Link></div> */}
                            <div id="container-arrow">
                                <Link to="./Projects#page-top" >   <button class="learn-more">
                                    <span class="circle" aria-hidden="true">
                                        <span class="icon arrow-new"></span>
                                    </span>
                                    <span class="button-text">My Projects</span>
                                </button></Link>
                            </div>
                        </div>
                        <div><img className="web-blog-img" src={MyProjmg} alt="projects logo" /></div>

                    </div>
                </Fade>
                <Fade right>
                    <div className="blog-card-intro">
                        <div className="project-web-section">
                            <div className="my-heading">My Blogs</div>
                            <div className="web-sub-text-my-section">I am also working on some technical and non techincal blogs.I like to
                                document my journey of learning.</div>
                            <div id="container-arrow">
                                <Link to="./Blogs" >   <button class="learn-more">
                                    <span class="circle" aria-hidden="true">
                                        <span class="icon arrow-new"></span>
                                    </span>
                                    <span class="button-text">My Blogs</span>
                                </button></Link>
                            </div>
                        </div>
                        <div><img className="web-blog-img" src={MyBlogsImg} alt="blogs logo" /></div>
                    </div>

                </Fade>
            </div>
        </>

    );
}
